import type { Messages } from './en.js';

/** Deutsch — Terminologie an die Landing angelehnt (Verlauf, Duplikate…). */
export const de: Messages = {
  // ── nav ────────────────────────────────────────────────────────────────
  'nav.timeline': 'Verlauf',
  'nav.search': 'Suche',
  'nav.duplicates': 'Duplikate',
  'nav.collections': 'Sammlungen',
  'nav.import': 'Import',
  'nav.trash': 'Papierkorb',
  'nav.settings': 'Einstellungen',

  // ── common actions ─────────────────────────────────────────────────────
  'common.restore': 'Wiederherstellen',
  'common.delete': 'Löschen',
  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.close': 'Schließen',
  'common.upgrade': 'Upgraden',
  'common.upgradeToPro': 'Auf Pro upgraden',
  'common.search': 'Suchen',
  'common.tryAgain': 'Erneut versuchen',
  'common.loading': 'Wird geladen…',
  'common.back': 'Zurück',
  'common.skip': 'Überspringen',
  'common.verify': 'Prüfen',
  'common.resend': 'Erneut senden',
  'common.free': 'Free',
  'common.pro': 'Pro',
  'common.clearFilters': 'Filter zurücksetzen',
  'common.addToChrome': 'Zu Chrome hinzufügen',
  'toast.genericError': 'Etwas ist schiefgelaufen. Bitte versuch es erneut.',

  // ── plural units ───────────────────────────────────────────────────────
  'unit.tabs.one': '{count} Tab',
  'unit.tabs.few': '{count} Tabs',
  'unit.tabs.many': '{count} Tabs',
  'unit.tabs.other': '{count} Tabs',
  'unit.sessions.one': '{count} Sitzung',
  'unit.sessions.few': '{count} Sitzungen',
  'unit.sessions.many': '{count} Sitzungen',
  'unit.sessions.other': '{count} Sitzungen',
  'unit.items.one': '{count} Eintrag',
  'unit.items.few': '{count} Einträge',
  'unit.items.many': '{count} Einträge',
  'unit.items.other': '{count} Einträge',
  'unit.entries.one': '{count} Eintrag',
  'unit.entries.few': '{count} Einträge',
  'unit.entries.many': '{count} Einträge',
  'unit.entries.other': '{count} Einträge',
  'unit.copies.one': '{count} Kopie',
  'unit.copies.few': '{count} Kopien',
  'unit.copies.many': '{count} Kopien',
  'unit.copies.other': '{count} Kopien',
  'unit.browsers.one': '{count} Browser',
  'unit.browsers.few': '{count} Browser',
  'unit.browsers.many': '{count} Browser',
  'unit.browsers.other': '{count} Browser',

  // ── app shell ──────────────────────────────────────────────────────────
  'shell.searchPlaceholder': 'Deinen Vault durchsuchen…',
  'shell.saved': 'GESICHERT',
  'shell.toggleTheme': 'Theme wechseln',

  // ── timeline ───────────────────────────────────────────────────────────
  'timeline.empty.title': 'Dein Vault ist leer — noch',
  'timeline.empty.body':
    'Feg ein Fenster mit der Nomad Tabs-Erweiterung hinein oder rette deinen alten OneTab-Friedhof. Alles landet hier — durchsuchbar.',
  'timeline.empty.import': 'Tabs importieren',
  'timeline.empty.importOneTab': 'Aus OneTab importieren',
  'timeline.empty.tip': 'TIPP: ⇧⌘S FEGT DAS AKTUELLE FENSTER AUS DER ERWEITERUNG',
  'timeline.noMatch.title': 'Keine Sitzung passt zu diesen Filtern',
  'timeline.noMatch.body': 'Probiere einen größeren Zeitraum, einen anderen Browser oder schalte „nur mit Inhalt“ aus.',
  'timeline.loadOlder': 'Ältere Sitzungen laden',
  'timeline.toast.sessionDeleted': 'Sitzung gelöscht',
  'timeline.toast.loadFailed': 'Diese Sitzung konnte nicht geladen werden',
  'timeline.delete.title': 'Diese Sitzung löschen?',
  'timeline.delete.subtitle': 'Entfernt „{title}“ und die {tabs} darin. Das lässt sich nicht rückgängig machen.',
  'timeline.delete.body': 'Falls du es dir anders überlegst: Die Tabs findest du weiterhin im Browserverlauf.',
  'timeline.delete.confirm': 'Sitzung löschen',
  'timeline.delete.fallbackTitle': 'diese Sitzung',
  'timeline.offline.title': 'Du bist offline',
  'timeline.offline.body': 'Dein Vault arbeitet lokal weiter — die Synchronisierung läuft von selbst wieder an, sobald du online bist.',
  'timeline.error.title': 'Verlauf konnte nicht geladen werden',
  'timeline.error.body': 'Der Vault war nicht erreichbar. Prüfe deine Verbindung und versuch es erneut.',

  // ── search ─────────────────────────────────────────────────────────────
  'search.mode.text': 'Text',
  'search.mode.hybrid': 'Hybrid',
  'search.mode.semantic': 'Semantisch',
  'search.placeholder': 'Deinen Vault durchsuchen…',
  'search.clear': 'Suche löschen',
  'search.status.counted': 'DURCHSUCHE {count} TABS',
  'search.status.default': 'DURCHSUCHE DEINEN VAULT',
  'search.empty.title': 'Durchsuche alles, was du gespeichert hast',
  'search.empty.body':
    'Finde einen Tab über den Titel, die Adresse oder die Wörter auf der Seite. Der semantische Modus findet ihn über die Bedeutung.',
  'search.noMatch.title': 'Keine Treffer für „{q}“',
  'search.noMatch.body': 'Probiere weniger oder andere Wörter, wechsle in den Hybrid-Modus oder setze die Filter zurück.',
  'search.failed.eyebrow': '— SUCHE FEHLGESCHLAGEN',
  'search.failed.body': 'Dein Vault war nicht erreichbar.',
  'search.failed.retryHint': 'Versuch es noch einmal.',
  'search.results': '{count} TREFFER',
  'search.sort.relevance': 'Relevanz',
  'search.sort.date': 'Datum',
  'search.loadMore': 'Mehr Treffer laden',
  'search.bestMatch': 'BESTER TREFFER',
  'search.openedIn': 'GEÖFFNET IN {browser}',
  'search.facet.browser': 'BROWSER',
  'search.facet.date': 'DATUM',
  'search.facet.topDomains': 'TOP-DOMAINS',
  'search.range.any': 'Beliebige Zeit',
  'search.range.24h': '24 Stunden',
  'search.range.7d': '7 Tage',
  'search.range.30d': '30 Tage',
  'search.range.1y': '12 Monate',
  'search.upsell.eyebrow': 'SEMANTISCHE SUCHE · PRO',
  'search.upsell.title': 'Die semantische Suche ist ein Pro-Feature',
  'search.upsell.body':
    'Finde Tabs über ihre Bedeutung, nicht nur über Stichwörter — „der Artikel über die Zinssenkung der Zentralbank“ statt des exakten Titels. Mit Pro durchsuchst du alles, was du je gespeichert hast.',
  'search.upsell.seePlans': 'Pro-Tarife ansehen',
  'search.upsell.useText': 'Stattdessen per Text suchen',

  // ── duplicates ─────────────────────────────────────────────────────────
  'dupes.title': 'Duplikate-Center',
  'dupes.summary.duplicates': '{count} DUPLIKATE',
  'dupes.summary.ram': '≈ {ram} RAM FREIZUGEBEN',
  'dupes.closeSelected': 'Ausgewählte schließen ({count})',
  'dupes.keepNewest': 'Neueste behalten, Rest schließen',
  'dupes.error.title': 'Duplikate konnten nicht geladen werden',
  'dupes.toast.closed': '{copies} geschlossen',
  'dupes.toast.closedBody': 'Die neueste Kopie bleibt offen — jede Kopie bleibt in deinem Vault gespeichert.',

  // ── collections ────────────────────────────────────────────────────────
  'collections.title': 'Sammlungen',
  'collections.subtitle': 'Automatisch per KI sortiert — jederzeit umbenennen oder zusammenführen',
  'collections.new': 'Neue Sammlung',
  'collections.banner.title': 'Automatische KI-Sammlungen sind ein Pro-Feature.',
  'collections.banner.body': 'Sammlungen von Hand anlegen und pflegen kannst du trotzdem — kostenlos, für immer.',
  'collections.empty.title': 'Noch keine Sammlungen',
  'collections.empty.body':
    'Gruppiere Tabs nach Thema. Leg eine von Hand an — Pro sortiert deinen Vault zusätzlich automatisch in Sammlungen.',
  'collections.error.title': 'Sammlungen konnten nicht geladen werden',

  // ── import ─────────────────────────────────────────────────────────────
  'import.title': 'Importiere deine alten Tab-Friedhöfe',
  'import.drop.title': 'Zieh deine Exportdatei hierher',
  'import.drop.body': 'OneTab, Session Buddy oder Lesezeichen-HTML —',
  'import.drop.browse': 'Datei auswählen',
  'import.readyEyebrow': 'BEREIT ZUM IMPORT',

  // ── settings ───────────────────────────────────────────────────────────
  'settings.title': 'Einstellungen',
  'settings.section.account': 'KONTO & SYNC',
  'settings.section.browsers': 'VERBUNDENE BROWSER',
  'settings.section.capture': 'ERFASSUNGSREGELN',
  'settings.section.sharing': 'TEILEN',
  'settings.section.storage': 'SPEICHER',
  'settings.section.appearance': 'DARSTELLUNG',
  'settings.section.language': 'SPRACHE',
  'settings.section.about': 'ÜBER',
  'settings.section.danger': 'GEFAHRENZONE',
  'settings.account.private': 'PRIVAT & SICHER',
  'settings.account.yourAccount': 'Dein Konto',
  'settings.account.proPlan': 'PRO-TARIF',
  'settings.account.freePlan': 'FREE-TARIF',
  'settings.account.managePlan': 'Tarif verwalten',
  'settings.account.seePro': 'Pro ansehen',
  'settings.account.privacyNote':
    'Deine gespeicherten Seiten bleiben privat — nur du kannst sie sehen. Wir halten sie sicher und außer Reichweite aller anderen.',
  'settings.account.billing': 'Abrechnung & Zahlungen',
  'settings.browsers.syncAuto': 'Weitere synchronisieren sich automatisch',
  'settings.browsers.thisBrowser': 'Dieser Browser',
  'settings.browsers.webApp': 'WEB-APP',
  'settings.browsers.activeNow': 'JETZT AKTIV',
  'settings.browsers.installHint':
    'Installiere die Erweiterung in deinen anderen Browsern — sie tauchen hier auf und synchronisieren sich automatisch.',
  'settings.capture.onDevice': 'AUF DIESEM GERÄT',
  'settings.capture.saveContent': 'Seiteninhalt für die Suche speichern',
  'settings.capture.saveContentDesc': 'Nur Text — privat gespeichert für die Volltextsuche',
  'settings.capture.skipIncognito': 'Inkognito-Fenster überspringen',
  'settings.capture.neverOn': 'Inhalte niemals erfassen auf:',
  'settings.capture.addSite': '+ Website hinzufügen',
  'settings.capture.localNote':
    'Diese Regeln leben vorerst in diesem Browser — die Synchronisierung zwischen Geräten kommt bald.',
  'settings.sharing.readOnly': 'Öffentliche Links, nur Lesezugriff',
  'settings.sharing.collection': 'Sammlung',
  'settings.sharing.sweep': 'Sweep',
  'settings.sharing.selectCollection': 'Sammlung wählen…',
  'settings.sharing.selectSweep': 'Sweep wählen…',
  'settings.sharing.createLink': 'Link erstellen',
  'settings.sharing.empty.title': 'Noch keine geteilten Links',
  'settings.sharing.empty.body': 'Erstelle einen öffentlichen Link für eine Sammlung oder einen Sweep — nur Lesezugriff.',
  'settings.sharing.copyLink': 'Link kopieren',
  'settings.sharing.revoke': 'Widerrufen',
  'settings.toast.linkCreated': 'Link erstellt',
  'settings.toast.linkCreatedBody': 'Jeder mit dem Link kann ihn ansehen — nur lesend.',
  'settings.toast.linkFailed': 'Link konnte nicht erstellt werden',
  'settings.toast.linkFailedBody': 'Bitte versuch es gleich noch einmal.',
  'settings.toast.linkRevoked': 'Link widerrufen',
  'settings.toast.linkRevokedBody': 'Dieser Link öffnet sich nicht mehr.',
  'settings.toast.revokeFailed': 'Link konnte nicht widerrufen werden',
  'settings.toast.revokeFailedBody': 'Bitte versuch es erneut.',
  'settings.toast.copied': 'Kopiert',
  'settings.toast.copiedBody': 'Der Link liegt in deiner Zwischenablage.',
  'settings.toast.deleteFailed': 'Löschen fehlgeschlagen',
  'settings.toast.deleteFailedBody': 'Das Konto konnte nicht gelöscht werden. Versuch es erneut.',
  'settings.danger.export': 'Alle Daten exportieren',
  'settings.danger.deleteAccount': 'Konto & Daten löschen',
  'settings.danger.note': 'Erst exportieren — nach 14 Tagen ist das Löschen endgültig.',
  'settings.storage.saved': '{count} gespeichert',
  'settings.storage.tabs': 'TABS',
  'settings.storage.sessions': 'SITZUNGEN',
  'settings.storage.indexed': 'INDIZIERT',
  'settings.appearance.dark': 'Dunkles Theme',
  'settings.appearance.darkDesc': 'Tiefes Marineblau — der Standard-Look',
  'settings.language.label': 'Anzeigesprache',
  'settings.language.desc': 'Gilt sofort, überall in der App.',
  'settings.promo.title': 'Hol dir die Erweiterung',
  'settings.promo.body': 'Feg ein ganzes Fenster mit einem Klick — direkt aus deiner Symbolleiste.',
  'settings.about.webApp': 'Web-App',
  'settings.about.extension': 'Erweiterung',
  'settings.deleteModal.title': 'Konto & Daten löschen',
  'settings.deleteModal.subtitle': 'Das entfernt deinen Vault überall.',
  'settings.deleteModal.body':
    'Jeder Sweep, jede gespeicherte Seite und jede Sammlung wird zum Löschen vorgemerkt. 14 Tage lang bleibt alles wiederherstellbar, dann ist es endgültig weg. Exportiere deine Daten vorher, falls du sie noch brauchen könntest.',
  'settings.deleteModal.keep': 'Konto behalten',
  'settings.deleteModal.confirm': 'Alles löschen',
  'settings.planModal.title': 'Deinen Pro-Tarif verwalten',
  'settings.planModal.subtitle': 'Free bleibt großzügig — Pro verbindet alles.',
  'settings.planModal.body':
    'Kündige jederzeit — Pro läuft bis zum Ende des bezahlten Zeitraums weiter. Danach: lokale Speicherungen bleiben unbegrenzt, die Synchronisierung sinkt auf einen Browser, und KI-Suche und Sammlungen pausieren.',
  'settings.planModal.nothingDeleted': 'Nichts wird gelöscht.',
  'settings.planModal.emailSupport': 'Support zum Kündigen anschreiben',
  'settings.planModal.keepPro': 'Pro behalten',

  // ── login / verify ─────────────────────────────────────────────────────
  'login.welcome': 'Willkommen bei Nomad Tabs',
  'login.tagline': 'Ein Vault für jeden Browser, den du nutzt.',
  'login.emailPlaceholder': 'du@email.com',
  'login.sendLink': 'Magic Link senden',
  'login.error.tooMany': 'Zu viele Anfragen — warte eine Minute und versuch es erneut.',
  'login.error.sendFailed': 'Der Link konnte gerade nicht gesendet werden. Versuch es gleich noch einmal.',
  'login.reassure': 'Deine gespeicherten Seiten bleiben privat — nur du kannst deinen Vault öffnen.',
  'login.checkInbox': 'Schau in dein Postfach',
  'login.sentTo': 'Wir haben einen Anmeldelink gesendet an',
  'login.expires': 'LINK LÄUFT IN 15 MIN AB',
  'login.nothingThere': 'Nichts angekommen?',
  'login.checkSpam': 'Spam prüfen',
  'login.wrongAddress': '← Falsche Adresse? Zurück',
  'login.devDivider': 'DEV · TOKEN EINFÜGEN',
  'login.tokenPlaceholder': 'Token aus der API-Konsole',
  'verify.signingIn': 'Du wirst angemeldet…',
  'verify.hangTight': 'Einen Moment, das dauert nur eine Sekunde.',
  'verify.expired.title': 'Dieser Link ist abgelaufen',
  'verify.expired.body':
    'Magic Links gelten 15 Minuten und nur einmal. Fordere einen neuen an und du bist sofort drin.',
  'verify.backToSignIn': 'Zurück zur Anmeldung',

  // ── onboarding ─────────────────────────────────────────────────────────
  'onboarding.hero.title1': 'Dein Browser hat endlich',
  'onboarding.hero.title2': 'ein Gedächtnis.',
  'onboarding.hero.body':
    'Feg ganze Fenster in deinen Vault, schließe sie ohne Angst und finde jede Seite wieder — über das, was darauf stand.',
  'onboarding.getStarted': 'Loslegen',
  'onboarding.hero.micro': 'DAUERT 60 SEKUNDEN · ERKUNDEN OHNE KONTO MÖGLICH',
  'onboarding.perm.title': 'Warum dein Browser nach Zugriff fragt',
  'onboarding.perm.lede': 'Die nächste Abfrage klingt beängstigend. Das bedeutet sie wirklich.',
  'onboarding.perm.head': '„ALLE IHRE DATEN AUF ALLEN WEBSITES LESEN UND ÄNDERN“ — ÜBERSETZT',
  'onboarding.perm.p1.title': 'Wir lesen Seiten nur, um sie durchsuchbar zu machen',
  'onboarding.perm.p1.body': 'Damit du später „den Artikel über Hypothekenzinsen“ wiederfindest.',
  'onboarding.perm.p2.title': 'Deine Seiten bleiben privat auf deinem Gerät',
  'onboarding.perm.p2.body': 'Nur du kannst deinen Vault öffnen — wir sehen nicht, was du speicherst.',
  'onboarding.perm.p3.title': 'Banken, E-Mail und private Seiten lassen sich ausschließen',
  'onboarding.perm.p3.body': 'Eine Liste in den Einstellungen — dort wird nie Inhalt erfasst.',
  'onboarding.perm.continue': 'Klingt fair — weiter',
  'onboarding.perm.later': 'Später fragen',
  'onboarding.perm.micro': 'DAS KANNST DU JEDERZEIT IN DEN EINSTELLUNGEN ÄNDERN',
  'onboarding.rescue.title': 'Rette deine Tabs, jetzt sofort',
  'onboarding.rescue.lede': 'Wähl eins — beides dauert unter einer Minute, und nichts geht verloren.',
  'onboarding.rescue.onetab.title': 'Aus OneTab importieren',
  'onboarding.rescue.onetab.body':
    'Hol deinen ganzen OneTab-Friedhof mit einem Klick herüber — Gruppen werden zu Sitzungen.',
  'onboarding.rescue.chooseFile': 'Datei wählen',
  'onboarding.rescue.onetab.foot': 'AUSSERDEM: SESSION BUDDY · LESEZEICHEN-HTML',
  'onboarding.rescue.ext.title': 'Hol dir die Browser-Erweiterung',
  'onboarding.rescue.ext.body':
    'Feg ein ganzes Fenster mit einem Klick, direkt aus der Symbolleiste. Sieh zu, wie dein RAM zurückkommt.',
  'onboarding.rescue.ext.foot': 'CHROME · EDGE · YANDEX · COMET',
  'onboarding.rescue.openApp': 'Web-App öffnen →',

  // ── pricing ────────────────────────────────────────────────────────────
  'pricing.title': 'Geh auf Pro, wenn du bereit bist',
  'pricing.subtitle': 'Free bleibt großzügig. Pro verbindet alles.',
  'pricing.monthly': 'Monatlich ${price}',
  'pricing.yearly': 'Jährlich ${price}',
  'pricing.forever': 'FÜR IMMER',
  'pricing.yourPlan': 'DEIN TARIF',
  'pricing.mostLoved': 'PUBLIKUMSLIEBLING',
  'pricing.perMonth': '/MON.',
  'pricing.perMonthYearly': '/MON. · ${total} PRO JAHR',
  'pricing.free.f1': 'Unbegrenzte lokale Speicherungen',
  'pricing.free.f2': '1 Browser mit Cloud-Sync',
  'pricing.free.f3': 'Suche nach Titel & URL',
  'pricing.free.f4': 'Volltext- & KI-Suche',
  'pricing.free.f5': 'KI-Sammlungen',
  'pricing.pro.f1': 'Alle Browser, alle Geräte synchronisiert',
  'pricing.pro.f2': 'Volltext + semantische KI-Suche',
  'pricing.pro.f3': 'KI-Sammlungen, die sich selbst sortieren',
  'pricing.pro.f4': 'Versionsverlauf gespeicherter Seiten',
  'pricing.pro.f5': 'Bevorzugter Support',
  'pricing.stayFree': 'Bei Free bleiben',
  'pricing.youreOnPro': 'Du bist auf Pro',
  'pricing.signInToUpgrade': 'Zum Upgraden anmelden',
  'pricing.checkoutSoon': 'Der Checkout öffnet bald — wir mailen dir, sobald es losgeht.',
  'pricing.checkoutFailed': 'Beim Start des Checkouts ist etwas schiefgelaufen. Bitte versuch es erneut.',
  'pricing.footer': 'JEDERZEIT KÜNDBAR · DATEN JEDERZEIT EXPORTIERBAR · LOKALE SPEICHERUNGEN WERDEN NIE GESPERRT',

  // ── billing / version history ──────────────────────────────────────────
  'billing.title': 'Abrechnung & Zahlungen',
  'versions.title': 'Versionsverlauf',
  'versions.current': 'AKTUELL',
  'versions.restoreThis': 'Diese Version wiederherstellen',

  // ── trash ──────────────────────────────────────────────────────────────
  'trash.title': 'Papierkorb',
  'trash.autoPurge': 'AUTOMATISCHE LEERUNG NACH 14 TAGEN',
  'trash.itemsLoading': '… EINTRÄGE',
  'trash.restoreSelected': 'Auswahl wiederherstellen ({count})',
  'trash.restoring': 'Wird wiederhergestellt…',
  'trash.emptyTrash': 'Papierkorb leeren',
  'trash.error.title': 'Papierkorb konnte nicht geladen werden',
  'trash.emptyState.title': 'Der Papierkorb ist leer',
  'trash.emptyState.body':
    'Gelöschte Sitzungen und Seiten warten hier 14 Tage, dann werden sie automatisch entfernt.',
  'trash.footNote': 'LÖSCHEN AUS DEM PAPIERKORB IST ENDGÜLTIG · DATENEXPORT JEDERZEIT IN EINSTELLUNGEN → GEFAHRENZONE',
  'trash.purge.title': 'Für immer löschen?',
  'trash.purge.subtitle': '„{title}“ wird endgültig entfernt — ohne die 14 Tage Wiederherstellung.',
  'trash.purge.confirm': 'Für immer löschen',
  'trash.purge.sweepBody': 'Das löscht die Sitzung und ihre {tabs} endgültig.',
  'trash.purge.pageBody': 'Das löscht die gespeicherte Seite und ihren erfassten Inhalt endgültig.',
  'trash.emptyConfirm.title': 'Papierkorb leeren?',
  'trash.emptyConfirm.subtitle': 'Löscht {entries} endgültig.',
  'trash.emptyConfirm.body':
    'Alles im Papierkorb ist danach für immer weg — das lässt sich nicht rückgängig machen. Deine Daten kannst du jederzeit in Einstellungen → Gefahrenzone exportieren.',
  'trash.toast.restored': 'Wiederhergestellt',
  'trash.toast.restoredBody': '„{title}“ ist zurück in deinem Vault.',
  'trash.toast.restoredMany': '{entries} wiederhergestellt',
  'trash.toast.restoreFailed': 'Wiederherstellen fehlgeschlagen',
  'trash.toast.restoreManyFailed': 'Auswahl konnte nicht wiederhergestellt werden',
  'trash.toast.purged': 'Für immer gelöscht',
  'trash.toast.purgedBody': '„{title}“ ist endgültig weg.',
  'trash.toast.purgeFailed': 'Löschen fehlgeschlagen',
  'trash.toast.emptied': 'Papierkorb geleert',
  'trash.toast.emptiedBody': 'Alles im Papierkorb wurde endgültig gelöscht.',
  'trash.toast.emptyFailed': 'Papierkorb konnte nicht geleert werden',
};
